import classNames from 'classnames';
import UiSvg from '../UiSvg';
import styles from './style.m.less';

interface Props {
    isSpinning?: boolean;
    className?: string;
}
function Spinner({ isSpinning = true, className, ...other }: Props) {
    const spinnerClasses = classNames(styles.container, className);
    return isSpinning ? <UiSvg className={spinnerClasses} name="loading-spinner" {...other} /> : <noscript />;
}

export default Spinner;
